import { render, staticRenderFns } from "./OrderListRootPage.vue?vue&type=template&id=7be0da0c&"
import script from "./OrderListRootPage.vue?vue&type=script&lang=js&"
export * from "./OrderListRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports